import type { ConnectionTier } from '@ts-classroom/enums'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

export interface ConnectionQualityMetrics {
  loss_pct: number | null
  rtt_ms: number | null
  jitter_ms: number | null
  limitation_reason: string | null
  livekit_quality: string | null
  peer_livekit_quality: string | null
  video_frozen_ms: number | null
  audio_concealment_pct: number | null
  own_reception_degraded: boolean
  peer_video_frozen_ms: number | null
  peer_audio_concealment_pct: number | null
  peer_reception_degraded: boolean | null
  uplink_impaired: boolean
  peer_uplink_impaired: boolean | null
  cpu_limited: boolean
  peer_cpu_limited: boolean | null
  browser: string | null
  os: string | null
}

interface ReportConnectionQualityApiReturn {
  reportConnectionQuality: (
    bookingId: number,
    tier: ConnectionTier,
    metrics: ConnectionQualityMetrics,
  ) => Promise<void>
}

export const useReportConnectionQualityApi = (): ReportConnectionQualityApiReturn => {
  const { $axios } = useNuxtApp()

  const reportConnectionQuality = async (
    bookingId: number,
    tier: ConnectionTier,
    metrics: ConnectionQualityMetrics,
  ): Promise<void> => {
    const url = useCsRoutes('classroom.lessons.connection-quality', {
      '[booking_id]': bookingId,
    })

    if (!url) {
      console.warn('missing url for classroom/report-connection-quality.hook.ts')
      return
    }

    try {
      await $axios.post(url, { tier, metrics })
    } catch (err) {
      console.error('unable to report classroom/report-connection-quality.hook.ts:', err)
    }
  }

  return { reportConnectionQuality }
}
